jQuery_T4NT(document).ready(function ($) {
  //check if in US and trigger popup to change sites
  var location = Intl.DateTimeFormat().resolvedOptions().timeZone.split("/");

  if (location[0] == "America") {
    var geoPopupCookie = getCookie("geolocation");
    if (!geoPopupCookie) {
      var modal = document.createElement("div");
      var modalContent = document.createElement("div");
      modal.className = "geo-popup";
      modalContent.className = "geo-popup__content";
      modalContent.innerHTML = `<div class="content__flag"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#FFF" viewBox="0 0 1235 650" width="100">
      <path d="M0 0h1235v650H0"></path>
      <path stroke="#b22234" stroke-dasharray="50" stroke-width="2470" d="M0 0v651"></path>
      <path fill="#3c3b6e" d="M0 0h494v350H0"></path>
      <g id="e">
          <g id="d">
              <g id="f">
                  <g id="c">
                      <g id="b">
                          <path id="a" d="m30 50.6 12-36 12 36-30.8-22H61"></path>
                          <use xlink:href="#a" x="82"></use>
                      </g>
                      <use xlink:href="#b" x="164"></use>
                      <use xlink:href="#a" x="328"></use>
                  </g>
                  <use xlink:href="#a" x="410"></use>
              </g>
              <use xlink:href="#c" x="41" y="35"></use>
          </g>
          <use xlink:href="#d" y="70"></use>
      </g>
      <use xlink:href="#e" y="140"></use>
      <use xlink:href="#f" y="280"></use>
  </svg></div><h2>You are viewing this site from the United States</h2><p><a href="https://us.photopaperdirect.com">Click here to visit our U.S. website</a></p><span class="close"><svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 256 256" id="Flat">
  <path fill="#ffffff" d="M202.82861,197.17188a3.99991,3.99991,0,1,1-5.65722,5.65624L128,133.65723,58.82861,202.82812a3.99991,3.99991,0,0,1-5.65722-5.65624L122.343,128,53.17139,58.82812a3.99991,3.99991,0,0,1,5.65722-5.65624L128,122.34277l69.17139-69.17089a3.99991,3.99991,0,0,1,5.65722,5.65624L133.657,128Z"/>
</svg></span>`;
      modal.appendChild(modalContent);
      document.querySelector("body").appendChild(modal);
      // window.onclick = function (event) {
      //   if (event.target == modal) {
      //     setCookie("geolocation", true, 1);
      //     modal.style.display = "none";
      //   }
      // };

      modal.querySelector(".close").addEventListener("click", () => {
        setCookie("geolocation", true, 1);
        modal.style.display = "none";
      });
    }
  }
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
